/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { LIST_NOTES } from "./actionTypes"
import { listNotesError, listNotesSuccess } from "./actions"

//Include Both Helper File with needed methods
import { getNotes } from "../../../helpers/backend_helper"

function* get(action) {
  try {
    const response = yield call(getNotes, action.payload.idCurso)
    yield put(listNotesSuccess(response))
  } catch (error) {
    yield put(listNotesError(error))
  }
}

function* notesListSaga() {
  yield takeEvery(LIST_NOTES, get)
}

export default notesListSaga
